// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3408":"9504ac8aed65f428","8294":"a330481fadabe457"}[chunkId] + ".js";
};